
<template>
  <vx-card class="overflow-hidden shadow-md">
    <div slot="no-body">
      <div
        class="p-6 pb-0"
        :class="{'flex justify-between flex-row-reverse items-center': iconRight}"
      >
        <feather-icon
          :icon="icon"
          class="p-3 inline-flex rounded-full"
          :class="[`text-${color}`, {'mb-4': !iconRight}]"
          :style="{background: `rgba(var(--vs-${color}),.15)`}"
        ></feather-icon>
        <div>
          <h2 class="mb-1 font-bold pl-4">{{ statistic }}</h2>
          <span>{{ statisticTitle }}</span>
        </div>
      </div>

      <div class="line-area-chart" v-if="type == 'bar'">
        <bars
          :data="[ 1,2,6,5,4,8,9,7,6]"
          :gradient="['#a7eaaa', '#28C76F']"
          :height="97"
          :barWidth="8"
          :growDuration="1"
        ></bars>
      </div>
      <div class="line-area-chart" v-if="type == 'trendLocation'">
        <trend
          :data="[0, 8, 5, 9, 5, 10, 7, 5, 6, 3, 1, 8, 2, 9, 0]"
          :gradient="['#FF9F43', '#ffc58e', '#cc7f35']"
          :stroke-width="5"
          :height="97"
          auto-draw
          smooth
        ></trend>
      </div>
      <div class="line-area-chart" v-if="type == 'trendZone'">
        <trend
          :data="[0, 7, 3, 9, 5, 10, 3, 5, 4, 2, 3, 9, 3, 8, 6]"
          :gradient="['#1E1E1E', '#8e8e8e', '#0c0c0c']"
          :stroke-width="5"
          :height="97"
          auto-draw
          smooth
        ></trend>
      </div>
    </div>
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props: {
    icon: {
      type: String,
      required: true
    },
    statistic: {
      type: [Number, String],
      required: true
    },
    statisticTitle: {
      type: String
    },
    color: {
      type: String,
      default: "primary"
    },
    chartType: {
      type: String,
      default: "line-chart"
    },
    type: {
      type: String,
      default: "line"
    },
    iconRight: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getHex() {
      let rgb = window
        .getComputedStyle(document.documentElement)
        .getPropertyValue(`--vs-${this.color}`);
      rgb = rgb.split(",");
      return (
        "#" +
        (
          (1 << 24) +
          (Number(rgb[0]) << 16) +
          (Number(rgb[1]) << 8) +
          Number(rgb[2])
        )
          .toString(16)
          .slice(1)
      );
    }
  },
  created() {}
};
</script>